var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FOCUSED MODE MEDIA MODALS BOOK AND ACTIVITY SIZE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4874 -2589C-4874 -2590.1 -4873.1 -2591 -4872 -2591H4523C4524.1 -2591 4525 -2590.1 4525 -2589V190C4525 191.104 4524.1 192 4523 192H-4872C-4873.1 192 -4874 191.104 -4874 190V-2589Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4872 -2590H4523V-2592H-4872V-2590ZM4524 -2589V190H4526V-2589H4524ZM4523 191H-4872V193H4523V191ZM-4873 190V-2589H-4875V190H-4873ZM-4872 191C-4872.55 191 -4873 190.552 -4873 190H-4875C-4875 191.657 -4873.66 193 -4872 193V191ZM4524 190C4524 190.552 4523.55 191 4523 191V193C4524.66 193 4526 191.657 4526 190H4524ZM4523 -2590C4523.55 -2590 4524 -2589.55 4524 -2589H4526C4526 -2590.66 4524.66 -2592 4523 -2592V-2590ZM-4872 -2592C-4873.66 -2592 -4875 -2590.66 -4875 -2589H-4873C-4873 -2589.55 -4872.55 -2590 -4872 -2590V-2592Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "student focused mode with image preview open in activity - horizontally longer",
    clipPath: "url(#clip0_6444_16538)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    transform: "translate(-1051 -1069)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "activity completetion mode"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_6444_16538",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-331 -989C-331 -993.418 -327.418 -997 -323 -997H677V48H-331V-989Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-331 -989C-331 -993.418 -327.418 -997 -323 -997H677V48H-331V-989Z",
    fill: "#FAFAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-332 -989C-332 -993.971 -327.971 -998 -323 -998H677V-996H-323C-326.866 -996 -330 -992.866 -330 -989H-332ZM677 48H-331H677ZM-332 48V-989C-332 -993.971 -327.971 -998 -323 -998V-996C-326.866 -996 -330 -992.866 -330 -989V48H-332ZM677 -997V48V-997Z",
    fill: "#9D9690",
    mask: "url(#path-3-inside-1_6444_16538)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Focus mode buttons"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32.5,
    y: -11.5,
    width: 177,
    height: 35,
    rx: 17.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32.5,
    y: -11.5,
    width: 177,
    height: 35,
    rx: 17.5,
    stroke: "#AD6302"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3333 6H3.66663",
    stroke: "#AD6302",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.49996 11.8327L3.66663 5.99935L9.49996 0.166016",
    stroke: "#AD6302",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "centerfold video view"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 570",
    x: -291,
    y: -997,
    width: 856,
    height: 1045,
    rx: 4,
    fill: "#2E2E2D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1797"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -267,
    y: -4,
    width: 299,
    height: 32,
    rx: 4,
    fill: "#2E2E2D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 5V19",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5 12H19",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6444_16538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    fill: "white",
    transform: "translate(-1051 -1069)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.edc91d066b7bedbb00c536f1411b61d8.svg";
export { ForwardRef as ReactComponent };